export const NAME = 'pupils'
export const PATH = `/${NAME}/`
export const PATH_PL = '/uczestnicy/'